module.exports = __webpack_public_path__ + "assets/images/amountofPaintings-03.de48b51385404f872d2ba51a70bf9d07.svg";